import { HttpResponse, http } from "msw";
import { apiPaths } from "../../api-paths.js";

const createRestoreBookingNumberHandler = (status = 200) => [
  http.post(`**${apiPaths.trips.restoreBookingNumber}`, async () => {
    if (status === 204) {
      return new HttpResponse(null, { status: 204 });
    }

    return HttpResponse.text("", { status });
  }),
];

export const restoreBookingNumber = {
  postRestoreBookingNumber: createRestoreBookingNumberHandler(),
  postRestoreBookingNumberNoContent: createRestoreBookingNumberHandler(204),
};
